import React, { Component } from 'react';
import { HandleSubmit } from '../../func/HandleSubmit';
import AddUser from "../User/AddUser";
import DeleteUser from './DeleteUser';
import ReactTable from 'react-table-6'

class ListUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TableRow: [],
            Validation: {},
            Loading: true,
            TableOfUser: {}
        };
        this.GetTableOfUser = this.GetTableOfUser.bind(this);
    }
    async GetTableOfUser() {
        var response_info = await HandleSubmit('user/getlist', '');
        this.setState({
            TableOfUser: (response_info),
        });
        console.log("response_info", response_info);
    }
    async DeleteRow(item) {
        await DeleteUser(item);
        await this.InitList();
    }
    async InitList() {
        this.setState({
            Loading: true,
            TableRow: [],

        });
        await this.GetTableOfUser();
        this.setState({
            Loading: false
        });
    }
    async componentDidMount() {
        this.InitList();
    }
    render() {
        if (this.state.Loading) { return "Loading..." }
        return (
            <div>
                <AddUser initlist={() => this.InitList()} />
                <ReactTable
                    className="-striped -highlight"
                    showPagination={false}
                    minRows={0}
                    headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                    data={this.state.TableOfUser}
                    columns={[
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 20,
                            Cell: row => (row.value)
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>  نام کاربری </div>,
                            accessor: "user",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>نام </div>,
                            accessor: "name",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>گروه </div>,
                            accessor: "groupname",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}></div>,
                            Cell: (rowinfo) => <button className="btn btn-outline-danger" onClick={() => (
                                this.DeleteRow(rowinfo.original.user)
                            )}>حذف </button>
                        }
                    ]}
                    className="-striped -highlight"
                />
            </div >

        );
    }
}
export default (ListUser);







// WEBPACK FOOTER //
// ./src/pages/User/ListUser.js